import React from 'react';
import styled from 'styled-components/macro';
import { ReactComponent as CreateIcon } from 'assets/icons/plus-custom.svg';
import RouterProvider from 'components/RouterProvider/RouterProvider';
import { useFormatMessage } from 'components/IntlProvider';

const { Link, ROUTES } = RouterProvider;

const StyledButton = styled(Link)`
  background-color: #1f5dea;
  padding: 0.625rem 1.5rem;
  border-radius: 2rem;
  color: #ffffff !important;
  font-weight: 700;
  display: flex;
  align-items: center;

  svg {
    margin-left: 0.5rem;
    width: 1rem;
    height: 1rem;
    fill: #ffffff;
  }

  &:hover {
    background-color: #0f44bb;
  }
`;

const ProjectTopNavbar = () => {
  const t = useFormatMessage();

  return (
    <>
      <StyledButton to={ROUTES.PROJECTS.CREATE}>
        {t('dashboard.menu.addproject', 'New Project')} <CreateIcon />
      </StyledButton>
    </>
  );
};

export default ProjectTopNavbar;
